import Vue from 'vue';
import Router from 'vue-router';

import Product from '../views/brush/Product';
import About from '../views/brush/About';

Vue.use(Router);

const brushFaceRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'product',
      component: Product,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
  ],
});

export default brushFaceRouter;
